import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LogisticsShareable } from 'globals/store/share.data';
import { ShareWrapper } from './share-wrapper.component';
import { environment } from '../../../environments/environment';
import { BrandingData } from 'globals/store/publish.data';
import { FullLogisticsShareData, LogisticsShareData } from 'globals/store/logistics.data';
import { LogisticsShareView } from '../logistics/logistics-share-view.component';

@Component({
    selector: 'share-logistics',
    template: `
<logistics-share-view
  [unavailable]="unavailable"
  [loading]="loading"
  [shareData]="shareData"
  [brandingData]="brandingData"
  [logisticsShareable]="selectedShare"
></logistics-share-view>
`,
    styleUrls: ['./share-logistics.scss'],
    standalone: true,
    imports: [LogisticsShareView]
})
export class ShareLogisticsComponent extends ShareWrapper<ShareLogisticsComponent> {
    publishCode:string;
    loading:boolean = true;
    unavailable: boolean = false;
    submitted:boolean;
    readonly api = `${environment.functionsURL}api/v1`; // NOTE this is pointing to api/v1 not api/app

    brandingData: BrandingData
    selectedShare: LogisticsShareable
    shareData: LogisticsShareData
    
    constructor(private route:ActivatedRoute) {
      super()
      document.title = "loading";
      this.route.params.subscribe(params=> {
        if(!params || !params.hasOwnProperty('publishCode')) {
          this.loading = false;
          this.unavailable = true
          document.title = "Unavailable";
        } else {
          this.publishCode = params.publishCode;
          const url = `${this.api}/load-logistics-view/${this.publishCode}`
          this.take1(this.http.get(url)).then((data: FullLogisticsShareData) => {
            console.log({ data })
            document.title = "Production View"
            this.loading = false
            this.brandingData = data.brandingData
            this.selectedShare = data.selectedShare
            this.shareData = data.shareData
          }, (error) => {
            console.log(error)
            this.loading = false;
            this.unavailable = true
            document.title = "Production View Unavailable";
          })
        } 
      })
    }
  
}

